import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb as BsBreadcrumb } from 'react-bootstrap';
import { Container } from './styles';

export interface IBreadcrumbItem {
    text: string;
    route?: string;
    action?: () => void;
}

interface IBreadcrumbProps {
    items?: IBreadcrumbItem[];
}

export const Breadcrumb: React.FC<IBreadcrumbProps> = ({
    items
}) => {

    const navigate = useNavigate();

    const itemsRender = items?.map((item, index) => {
        return (
            <BsBreadcrumb.Item key={`breadcrumb-${index}`}
                onClick={(event) => {
                    event.stopPropagation();
                    if (item.action) {
                        item.action();
                        return;
                    }
                    if (item.route) {
                        navigateTo(item.route);
                    }
                }}
            >
                {item.text}
            </BsBreadcrumb.Item>
        )
    });

    return (
        <Container>
            <BsBreadcrumb>
                <BsBreadcrumb.Item active>Sislog</BsBreadcrumb.Item>
                {itemsRender}
            </BsBreadcrumb>
        </Container>
    );

    function navigateTo(route: string) {
        navigate(route);
    }
}